<template>
  <div>
    <b-navbar
      ref="topNavbar"
      fixed="top"
      toggleable="xl"
      variant="white"
      class="px-2 py-2 top-navbar"
    >
      <b-container class="custom-container my-0">
        <b-navbar-brand
          class="d-xl-block d-none hidden-temp"
          :to="{ name: 'home.welcome-page' }"
        >
          <b-img
            v-bind="avatarProps"
            rounded
            alt="Logo"
            class=""
            src="/img/logo.svg"
          ></b-img>
        </b-navbar-brand>

        <!-- Grouped so the toggle + icon row stay on one line without forcing
             nowrap on the whole container (which would also stop the opened
             collapse menu below from dropping onto its own row). -->
        <div class="mobile-toggle-row d-flex align-items-center flex-nowrap">
          <b-navbar-toggle
            target="nav-collapse"
            class="border-0"
          ></b-navbar-toggle>

          <!-- Mobile/tablet brand: lives inside the toggle row so burger /
               logo / controls always share one line (space-between spreads
               them left / centre / right). Hidden below ~510px where there's
               no room (see .mobile-brand media rule). -->
          <b-navbar-brand
            class="d-xl-none mobile-brand"
            :to="{ name: 'home.welcome-page' }"
          >
            <b-img
              v-bind="avatarProps"
              rounded
              alt="Logo"
              src="/img/logo.svg"
            ></b-img>
          </b-navbar-brand>

          <b-navbar-nav
            class="d-xl-none d-flex align-items-center flex-row flex-nowrap mx-0"
            style="min-width: 0; overflow: visible"
          >
            <!-- Mobile: Tokens button -->
            <b-nav-item
              v-if="!isTradieUser && canPurchaseTokens"
              class="px-1"
              @click.prevent="onPurchaseModal"
            >
              <b-button
                variant="primary"
                size="sm"
                style="
                  font-size: 0.72rem;
                  padding: 0.25rem 0.55rem;
                  white-space: nowrap;
                  line-height: 1.4;
                "
              >
                Tokens: {{ (balance && balance.available) || 0 }}
              </b-button>
            </b-nav-item>

            <b-nav-item-dropdown
              right
              lazy
              no-caret
              variant="link"
              toggle-class="px-0 text-decoration-none text-lg-left text-center"
              menu-class="py-0 my-0 position-absolute user-dropdown-menu-container"
              class="px-2 mr-2 user-dropdown"
              :disabled="userIsBusinessAdminRestricted"
            >
              <template #button-content>
                <b-button
                  variant="primary"
                  size="sm"
                  style="
                    font-size: 0.8rem;
                    padding: 0.25rem 0.6rem;
                    white-space: nowrap;
                    line-height: 1.4;
                  "
                  :disabled="userIsBusinessAdminRestricted"
                >
                  <b-icon-plus class="align-middle"></b-icon-plus>
                  <span class="align-middle">New</span>
                </b-button>
              </template>
              <b-dropdown-item
                @click="newFilePage()"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
              >
                <b-img
                  :src="require('@/assets/icons/file.svg')"
                  class="mr-3"
                  width="20px"
                  height="20px"
                ></b-img
                ><small>File</small></b-dropdown-item
              >
              <b-dropdown-item
                v-if="!isTradieUser"
                :to="{ name: 'request.templates-page' }"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
                ><b-img
                  :src="require('@/assets/icons/request.svg')"
                  class="mr-3"
                  width="20px"
                  height="20px"
                ></b-img
                ><small>Requests</small></b-dropdown-item
              >

              <b-dropdown-item
                v-if="!isTradieUser"
                @click="openMassNotificationFromMenu"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
              >
                <b-img
                  :src="require('@/assets/icons/message.svg')"
                  class="mr-3"
                  width="20px"
                  height="20px"
                ></b-img>
                <small>Send Message</small>
              </b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item
              class="notif-bell-item"
              @click="setShowNotificationList()"
            >
              <!-- prettier-ignore -->
              <div class="p-2">
              <div class="p-relative">
                <b-img :src="hover
                  ? require('@/assets/icons/bell.svg')
                  : require('@/assets/icons/bell-black.svg')" @mouseover="hover = true" @mouseleave="hover = false" />
                <b-badge v-if="unreadCount > 0" variant="danger" class="badge">
                  {{ unreadCount }}
                </b-badge>
              </div>
            </div>
            </b-nav-item>
            <b-nav-item-dropdown
              right
              lazy
              no-caret
              variant="link"
              toggle-class="px-0 text-decoration-none text-lg-left text-center"
              menu-class="py-0 my-0 position-absolute user-dropdown-menu-container"
              class="px-2 mr-2 user-dropdown"
            >
              <template #button-content>
                <b-avatar
                  button
                  v-if="userAvatar"
                  variant="light"
                  :src="userAvatar"
                ></b-avatar>
                <b-avatar
                  button
                  v-else
                  variant="primary"
                  :text="userInitials"
                ></b-avatar>
                <div v-if="user" class="d-none ml-lg-2 align-middle">
                  {{ user.full_name }}
                </div>
              </template>
              <b-dropdown-item
                :to="{ name: 'user.settings-page' }"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
              >
                <b-icon icon="gear" class="mr-3"></b-icon>
                <small>My Account</small>
              </b-dropdown-item>
              <!-- <b-dropdown-item
              :to="{ name: 'premium.subscription' }"
              link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
              class="align-middle border-bottom user-dropdown-item"
            >
              <b-img
                fluid
                alt="Tradie Pass Premium"
                class="mr-3"
                :src="require('@/assets/icons/king.svg')"
                :style="'width: 20px; height: 20px;'"
              ></b-img>
              <small>Tradie Pass Premium</small>
            </b-dropdown-item> -->
              <b-dropdown-item
                href="javascript:void(0)"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
                @click="signOut()"
              >
                <b-icon icon="box-arrow-right" class="mr-3"></b-icon>
                <small>Logout</small>
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </div>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="m-auto">
            <b-nav-item
              v-if="isTradieUser || hasPermission('home.view')"
              class="px-3 py-3"
              :active="isActive('home.welcome-page')"
              :to="{ name: 'home.welcome-page' }"
              >Home
            </b-nav-item>
            <b-nav-item
              v-if="isTradieUser || hasPermission('files.view')"
              class="px-3 py-3"
              :active="isActive('file.list-page')"
              :to="{ name: 'file.list-page' }"
              >Files</b-nav-item
            >
            <b-nav-item
              v-if="isTradieUser || hasPermission('requests.view')"
              class="px-3 py-3"
              :active="isActive('requests.list-page')"
              :to="{ name: 'requests.list-page' }"
              >Requests</b-nav-item
            >
            <b-nav-item
              v-if="!isTradieUser && hasPermission('tradies.view')"
              class="px-3 py-3"
              :active="isActive('tradies.list-page')"
              :to="{ name: 'tradies.list-page' }"
              >Tradies</b-nav-item
            >
            <b-nav-item
              v-if="
                isActiveSupervisorTradie ||
                (!isTradieUser && hasPermission('projects.view'))
              "
              class="px-3 py-3"
              :active="isActive('projects.list-page')"
              :to="supervisorNeedsToken ? null : { name: 'projects.list-page' }"
              @click="
                supervisorNeedsToken ? (showSupervisorTokenModal = true) : null
              "
              >Projects</b-nav-item
            >
            <b-nav-item
              v-if="!isTradieUser && hasPermission('trades.view')"
              class="px-3 py-3"
              :active="isActive('trades.list-page')"
              :to="{ name: 'trades.list-page' }"
              >Trades</b-nav-item
            >
            <b-nav-item
              v-if="
                isActiveSupervisorTradie ||
                (!isTradieUser && hasPermission('timesheets.view'))
              "
              class="px-3 py-3"
              :active="isActive('timesheets.list-page')"
              :to="
                supervisorNeedsToken ? null : { name: 'timesheets.list-page' }
              "
              @click="
                supervisorNeedsToken ? (showSupervisorTokenModal = true) : null
              "
              >Timesheets <span class="beta-tag">(Beta)</span></b-nav-item
            >
            <b-nav-item
              v-if="
                isActiveSupervisorTradie ||
                (!isTradieUser && hasPermission('schedule.view'))
              "
              class="px-3 py-3"
              :active="isActive('schedule.list-page')"
              :to="supervisorNeedsToken ? null : { name: 'schedule.list-page' }"
              @click="
                supervisorNeedsToken ? (showSupervisorTokenModal = true) : null
              "
              >Schedule <span class="beta-tag">(Beta)</span></b-nav-item
            >
            <b-nav-item
              v-if="isTradieUser && $env.openToWorkEnabled"
              class="px-3 py-3"
              :active="isActive('open-to-work.profile-page')"
              :to="{ name: 'open-to-work.profile-page' }"
              >Jobs <span class="beta-tag">(Beta)</span></b-nav-item
            >
            <!-- One Hiring tab for both hiring tools, candidate search (Job
                 Search) and posted jobs. The pill tabs inside the section
                 (CandidatesTabs) move between them. -->
            <b-nav-item
              v-if="hiringRoute"
              class="px-3 py-3"
              :active="isHiringActive"
              :to="hiringRoute"
              >Hiring</b-nav-item
            >
          </b-navbar-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="d-xl-flex d-none align-items-center">
            <b-button
              @click="onPurchaseModal"
              variant="primary"
              v-if="!isTradieUser && canPurchaseTokens"
              class="d-xl-flex align-items-center"
              style="white-space: nowrap; flex-shrink: 0"
            >
              <b-icon-plus font-scale="1.5" class="align-middle mr-2" />
              <span class="align-middle">
                Tokens: {{ (balance && balance.available) || 0 }}</span
              >
            </b-button>
            <purchase-token-modal
              v-if="canPurchaseTokens"
              :showModal="isPurchasingToken"
              @closeModal="onClosePurchaseModal"
              @purchase="onPurchaseTokens"
            />

            <b-modal
              v-model="showSupervisorTokenModal"
              centered
              ok-only
              ok-title="OK"
              title="Token Required"
            >
              A token must be assigned to your account before you can access
              Projects, Timesheets and Schedule. Please contact your company
              administrator to have a token assigned.
            </b-modal>

            <b-nav-item-dropdown
              v-if="hasAnyNewOption"
              right
              lazy
              no-caret
              variant="link"
              toggle-class="px-0 text-decoration-none text-lg-left text-center"
              menu-class="py-0 my-0 position-absolute user-dropdown-menu-container"
              class="px-2 mr-2 user-dropdown"
              :disabled="userIsBusinessAdminRestricted"
            >
              <template #button-content>
                <b-button variant="primary">
                  <b-icon-plus
                    font-scale="1.5"
                    class="align-middle"
                  ></b-icon-plus>
                  <span class="align-middle">New</span>
                </b-button>
              </template>

              <b-dropdown-item
                v-if="isTradieUser || hasPermission('files.upload')"
                @click="newFilePage()"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
              >
                <b-img
                  :src="require('@/assets/icons/file.svg')"
                  class="mr-3"
                  width="20px"
                  height="20px"
                ></b-img>
                <small v-if="isTradieUser">File</small>
                <small v-if="isBusinessAdminUser">Company File</small>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="!isTradieUser && hasPermission('requests.create')"
                :to="{ name: 'request.templates-page' }"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
                ><b-img
                  :src="require('@/assets/icons/request.svg')"
                  class="mr-3"
                  width="20px"
                  height="20px"
                ></b-img
                ><small>Requests</small></b-dropdown-item
              >

              <b-dropdown-item
                v-if="!isTradieUser && hasPermission('notifications.send')"
                @click="openMassNotificationFromMenu"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
              >
                <b-img
                  :src="require('@/assets/icons/message.svg')"
                  class="mr-3"
                  width="20px"
                  height="20px"
                ></b-img>
                <small>Send Message</small>
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item @click="setShowNotificationList()">
              <!-- prettier-ignore -->
              <div class="p-relative">
                <b-img :src="hover
                  ? require('@/assets/icons/bell.svg')
                  : require('@/assets/icons/bell-black.svg')" @mouseover="hover = true" @mouseleave="hover = false" />
                <b-badge v-if="unreadCount > 0" variant="danger" class="badge">
                  {{ unreadCount }}
                </b-badge>
              </div>
            </b-nav-item>
            <b-nav-item-dropdown
              right
              lazy
              no-caret
              variant="link"
              toggle-class="px-0 text-decoration-none text-lg-left text-center"
              menu-class="py-0 my-0 user-dropdown-menu-container"
              class="ml-lg-3 user-dropdown"
            >
              <template #button-content>
                <b-avatar
                  button
                  v-if="userAvatar"
                  variant="light"
                  :src="userAvatar"
                ></b-avatar>
                <b-avatar
                  button
                  v-else
                  variant="primary"
                  :text="userInitials"
                ></b-avatar>
                <div
                  v-if="user"
                  class="d-xl-none d-lg-none ml-lg-2 align-middle"
                >
                  {{ user.full_name }}
                </div>
              </template>
              <b-dropdown-item
                :to="{ name: 'user.settings-page' }"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
              >
                <b-icon icon="gear" class="mr-3"></b-icon>
                <small>My Account</small>
              </b-dropdown-item>
              <!-- <b-dropdown-item
                :to="{ name: 'premium.subscription' }"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
              >
                <b-img
                  :src="require('@/assets/icons/king.svg')"
                  class="mr-3"
                  width="20px"
                  height="20px"
                ></b-img>
                <small>Tradie Pass Premium</small>
              </b-dropdown-item> -->
              <b-dropdown-item
                href="javascript:void(0)"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
                @click="signOut()"
              >
                <b-icon icon="box-arrow-right" class="mr-3"></b-icon>
                <small>Logout</small>
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <notifications-list
      v-if="showNotificationList"
      :has-banner="!!resourceUpdateNotification"
      @close="closeNotificationList"
    ></notifications-list>

    <mass-notification-modal
      ref="massNotificationModal"
      v-model="isShareMassNotification"
      @sent="onMassNotificationSent"
    />

    <div
      v-if="showResourceBanner"
      ref="resourceBanner"
      class="resource-banner"
      :style="{ top: navbarHeight + 'px' }"
    >
      <div class="resource-banner__inner">
        <div class="resource-banner__icon-wrap">
          <b-icon icon="stars" class="resource-banner__icon" />
        </div>
        <div class="resource-banner__body">
          <span class="resource-banner__badge">NEW</span>
          <span class="resource-banner__label">What's New</span>
          <span
            class="resource-banner__message"
            v-html="resourceUpdateMessage"
          ></span>
        </div>
        <a
          :href="resourcesUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="resource-banner__cta"
        >
          See What's New
          <b-icon icon="arrow-right-short" class="resource-banner__cta-arrow" />
        </a>
      </div>
      <button
        type="button"
        class="resource-banner__close"
        aria-label="Dismiss"
        @click="dismissResourceBanner"
      >
        <b-icon icon="x" />
      </button>
    </div>
    <b-alert
      :show="profileCompletionDaysRemaining !== null"
      variant="warning"
      class="text-center mb-0 rounded-0 py-3 profile-completion-banner"
    >
      <strong
        >Your free trial ends in {{ profileCompletionDaysRemaining }} day{{
          profileCompletionDaysRemaining === 1 ? '' : 's'
        }}.</strong
      >
      Complete your company profile and purchase tokens to keep accessing shared
      projects.
    </b-alert>

    <b-overlay
      :show="show"
      rounded="sm"
      opacity="0.5"
      blur="1rem"
      id="overlay-background"
      class="min-vh-100"
    >
      <template #overlay>
        <div class="text-center">
          <digger-loader />
        </div>
      </template>
      <!-- No `p-0` here: its `!important` would override the inline
           paddingTop that reserves space for the resource banner. -->
      <!-- The notification panel is a position:fixed overlay drawer
           (NotificationsList, z-index 1030). It floats on top of the page
           and is dismissed by clicking anywhere else (handler below) — the
           page content must NOT reflow behind it. An earlier rule padded
           this container 400px on the right while the panel was open, which
           shrank every page into a 400px-narrower column on desktop and
           broke layouts that need the full width. -->
      <div
        class="slot-container m-0 full-width gray--bg"
        :style="{ paddingTop: contentOffsetForBanner + 'px' }"
        @click="closeNotificationList"
        :aria-hidden="show ? 'true' : null"
      >
        <router-view :key="routerViewKey" />
        <footer-section />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { canBuyTokens } from '@/utils/tokenAccess'
import { mapState, mapActions, mapGetters } from 'vuex'
import FooterSection from '@/components/FooterSection'
import NotificationsList from '@/components/lists/NotificationsList'
import PurchaseTokenModal from '@/components/modals/PurchaseTokenModal'
import MassNotificationModal from '@/components/modals/MassNotificationModal'
import {
  startIdleLogout,
  IDLE_TIMEOUT_MS,
  ADMIN_IDLE_TIMEOUT_MS,
} from '@/utils/idleLogout'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    FooterSection,
    NotificationsList,
    PurchaseTokenModal,
    MassNotificationModal,
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      device: (state) => state.device.deviceDetails,
    }),

    // The project pages read their id once, on load. Going from one project to
    // another (e.g. clicking a second project-file notification while already
    // on a project) reuses the page and leaves you on the old project, so key
    // them by project. Other routes, and ?tab= changes, keep the same key.
    routerViewKey() {
      const { name, params } = this.$route
      if (name === 'projects.view-page') return `${name}:${params.id}`
      if (name === 'projects.shared-view-page') {
        return `${name}:${params.shareId}`
      }
      return undefined
    },

    userAvatar() {
      return this.user && this.user.avatar ? this.user.avatar.url : ''
    },

    userInitials() {
      return this.user && this.user.full_name
        ? this.user.full_name
            .match(/(^\S\S?|\b\S)?/g)
            .join('')
            .match(/(^\S|\S$)?/g)
            .join('')
            .toUpperCase()
        : ''
    },

    isTradieUser() {
      return this.user ? this.user.user_type === 'tradie' : false
    },
    // Where the Hiring tab lands: candidate search when the admin has it,
    // otherwise Job Postings. null hides the tab.
    hiringRoute() {
      if (this.isTradieUser) return null
      if (
        this.$env.openToWorkEnabled &&
        this.hasPermission('candidates.view')
      ) {
        return { name: 'candidates.list-page' }
      }
      if (this.hasPermission('jobs.view')) return { name: 'jobs.list-page' }
      return null
    },
    isHiringActive() {
      const name = this.$route.name || ''
      return name.startsWith('candidates.') || name.startsWith('jobs.')
    },
    isBusinessAdminUser() {
      return this.user ? this.user.user_type === 'business_admin' : false
    },

    /**
     * Inactivity window before auto-logout: 30 minutes for business admins
     * (supervisors included) and supervisor tradies, 1 hour otherwise.
     */
    idleTimeoutMs() {
      return this.isBusinessAdminUser || this.isSupervisorTradie
        ? ADMIN_IDLE_TIMEOUT_MS
        : IDLE_TIMEOUT_MS
    },

    isFreeUser() {
      return this.user.is_free || false
    },
    ...mapGetters('notification', [
      'notifications',
      'unreadNotifications',
      'unreadCount',
    ]),
    ...mapGetters('token', ['balance']),
    ...mapGetters('auth', [
      'user',
      'hasPermission',
      'isSupervisorTradie',
      'isActiveSupervisorTradie',
      'isProjectScoped',
    ]),

    isBusinessAdmin() {
      return this.user && this.user.user_type === 'business_admin'
    },

    canPurchaseTokens() {
      return canBuyTokens(this.user, this.hasPermission)
    },

    supervisorNeedsToken() {
      return this.isSupervisorTradie && this.user && !this.user.has_token
    },

    userIsBusinessAdminWithoutToken() {
      return (
        this.user &&
        this.user.user_type === 'business_admin' &&
        !this.user.has_token
      )
    },

    userIsBusinessAdminNotVerified() {
      return (
        this.user &&
        this.user.user_type === 'business_admin' &&
        (!this.user.phone_number_verified || !this.user.email_verified)
      )
    },

    userIsBusinessAdminRestricted() {
      return (
        this.userIsBusinessAdminNotVerified ||
        this.userIsBusinessAdminWithoutToken
      )
    },

    /**
     * Days remaining in the project-share BA grace period. Returns null when
     * no countdown should show — no due date set, already gated by the API,
     * or already past the due date (either gated or completed). Otherwise the
     * countdown shows for the whole trial so the user sees it from first login.
     */
    profileCompletionDaysRemaining() {
      if (!this.user || !this.user.profile_completion_due_at) return null
      if (this.user.profile_completion_required) return null
      const due = new Date(this.user.profile_completion_due_at).getTime()
      if (Number.isNaN(due)) return null
      const msPerDay = 1000 * 60 * 60 * 24
      const days = Math.ceil((due - Date.now()) / msPerDay)
      if (days <= 0) return null
      return days
    },

    hasAnyNewOption() {
      if (this.isTradieUser) return true
      return (
        this.hasPermission('files.upload') ||
        this.hasPermission('requests.create') ||
        this.hasPermission('notifications.send')
      )
    },

    resourceUpdateNotification() {
      return (
        (this.unreadNotifications || []).find(
          (n) => n.type === 'resourceupdatednotification',
        ) || null
      )
    },

    showResourceBanner() {
      return (
        !!this.resourceUpdateNotification &&
        (this.isBusinessAdminUser || this.isSupervisorTradie)
      )
    },

    resourcesUrl() {
      const d =
        this.resourceUpdateNotification && this.resourceUpdateNotification.data
      const notifUrl = d && (d.url || d.link)
      if (notifUrl) return notifUrl
      const msg = (d && d.message) || ''
      const urlMatch = msg.match(/https?:\/\/[^\s.,!?)]+/)
      if (urlMatch) return urlMatch[0]
      return this.$env.cmsUrl + '/support/resources'
    },

    // Extra top padding to reserve for the resource banner. Pages already clear
    // the navbar on their own (see pageOwnNavClearance), so we only need to add
    // the banner's own height plus whatever the navbar exceeds that baseline by.
    contentOffsetForBanner() {
      if (!this.showResourceBanner) return 0
      return (
        this.bannerHeight +
        Math.max(0, this.navbarHeight - this.pageOwnNavClearance)
      )
    },

    resourceUpdateMessage() {
      const msg =
        (this.resourceUpdateNotification &&
          this.resourceUpdateNotification.data &&
          this.resourceUpdateNotification.data.message) ||
        ''
      // CMS sends rich-text HTML with <a> tags — ensure they open in a new tab
      // and won't be intercepted by Vue Router. Also auto-link bare URLs in plain text.
      return msg
        .replace(/<a\s/gi, '<a target="_blank" rel="noopener noreferrer" ')
        .replace(/(https?:\/\/[^\s.,!?)]+)/g, (url) =>
          msg.includes(`href="${url}"`) || msg.includes(`href='${url}'`)
            ? url
            : `<a href="${url}" target="_blank" rel="noopener noreferrer" class="alert-link">${url}</a>`,
        )
    },
  },

  data() {
    return {
      show: false,
      avatarProps: {
        height: 36,
      },
      hover: false,
      showNotificationList: false,
      isPurchasingToken: false,
      tokenQuantity: null,
      isShareMassNotification: false,
      showSupervisorTokenModal: false,
      // Measured at runtime so the fixed resource banner sits directly below the
      // navbar and reserves the correct amount of space on every screen size
      // (the navbar height and the banner's wrapped height both vary on mobile).
      navbarHeight: 88,
      bannerHeight: 52,
      // Every top-level page (Home, Projects, Tradies, Trades, Requests, Files)
      // already reserves this much space above its content via its own
      // `header-image pb-5` (3rem) + `custom-container mt-5` (3rem) markup, sized
      // to clear the navbar on its own. Only the shortfall between that baked-in
      // space and the navbar's real height needs to be made up here.
      pageOwnNavClearance: 96,
    }
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
      getAuthenticatedUser: 'auth/getAuthenticatedUser',
      getNotifications: 'notification/getNotifications',
      getUnreadNotifications: 'notification/getUnreadNotifications',
    }),
    ...mapActions('token', {
      purchase: 'purchase',
      getBalance: 'getBalance',
      getStatus: 'getStatus',
    }),
    signOut() {
      if (window.gapi) {
        window.gapi.auth2.getAuthInstance().signOut()
      }
      if (window.FB) {
        window.FB.logout()
      }
      this.logout()
    },

    startIdleTracking() {
      if (this._stopIdleLogout) {
        this._stopIdleLogout()
      }
      this._stopIdleLogout = startIdleLogout({
        timeoutMs: this.idleTimeoutMs,
        onIdle: () => this.signOut(),
      })
    },

    newFilePage() {
      if (this.userIsBusinessAdminRestricted) {
        return
      }
      if (this.isBusinessAdminUser) {
        // Company File upload — not on behalf of a tradie, so clear any
        // tradie context that may have been set by an earlier page (e.g.
        // a tradie profile) to avoid showing tradie-specific UI such as
        // the privacy consent checkbox.
        localStorage.removeItem('tradie_id')
      } else {
        localStorage.setItem('tradie_id', this.user.id)
      }
      localStorage.removeItem('project_id')

      this.$router.replace({ name: 'templates.list-page' })
    },

    onPurchaseModal() {
      if (!this.canPurchaseTokens) return
      this.isPurchasingToken = true
    },

    purchasingToken(status) {
      if (!status) {
        this.tokenQuantity = 1
      }
      this.isPurchasingToken = status
    },

    onClosePurchaseModal() {
      this.isPurchasingToken = false
    },

    async onPurchaseTokens(quantity) {
      if (!quantity || quantity < 1) {
        return
      }

      await this.purchase(quantity).catch((err) => this.handleError(err))
      this.getBalance()
      this.isPurchasingToken = false
    },

    handleError(err) {
      this.$bvToast.toast(
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : err.message || 'An unexpected error occurred',
        {
          title: 'Oops.. Something went wrong!',
          variant: 'danger',
          autoHideDelay: 3000,
        },
      )
    },

    async getUserNotifications() {
      await this.getUnreadNotifications()
      await this.getNotifications()
    },

    setShowNotificationList() {
      const opening = this.showNotificationList !== true
      this.showNotificationList = opening
      // Was only refetched on close (below), never on open — so answering a
      // resume request/workforce invitation elsewhere (e.g. the Open to
      // Work Requests page, which never touches this Vuex cache) and then
      // opening the bell showed the stale pre-response list: still unread,
      // with working Accept/Decline buttons for something already decided.
      if (opening) {
        this.getUserNotifications()
      }
    },

    closeNotificationList() {
      if (!this.showNotificationList) {
        return
      }
      this.showNotificationList = false
      this.getUserNotifications()
    },

    isActive(page) {
      return page === this.$route.name
    },

    onMassNotificationSent(payload) {
      const droppedReason = payload && payload.droppedAttachmentReason
      if (droppedReason) {
        this.$bvToast.toast(
          `Notification sent, but an attachment could not be included: ${droppedReason}`,
          {
            title: 'Notification sent',
            variant: 'warning',
            autoHideDelay: 6000,
          },
        )
      } else {
        this.$bvToast.toast('Notification sent.', {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 3000,
        })
      }
      this.getUserNotifications()
      this.$root.$emit('refreshMessagesLog')
    },

    openMassNotificationFromMenu() {
      if (this.userIsBusinessAdminRestricted) {
        return
      }
      this.isShareMassNotification = true
    },

    async dismissResourceBanner() {
      const notif = this.resourceUpdateNotification
      if (!notif) return
      // Optimistically remove from the unread list so the banner hides immediately.
      this.$store.commit(
        'notification/setUnreadNotifications',
        this.unreadNotifications.filter((n) => n.id !== notif.id),
      )
      try {
        await this.$api.put('notifications', { notification_id: notif.id })
        await this.getUnreadNotifications()
      } catch (e) {
        // best effort
      }
    },

    // Re-measure the navbar and resource banner so the banner is positioned
    // directly below the navbar and the page content is offset by the banner's
    // actual (possibly wrapped) height. Kept in sync on resize/orientation
    // change and whenever the banner appears or disappears.
    measureLayout() {
      this.$nextTick(() => {
        const navEl = this.$refs.topNavbar && this.$refs.topNavbar.$el
        if (navEl) {
          const h = Math.round(navEl.getBoundingClientRect().height)
          if (h > 0) this.navbarHeight = h
        }
        const bannerEl = this.$refs.resourceBanner
        if (bannerEl) {
          const bh = Math.round(bannerEl.getBoundingClientRect().height)
          if (bh > 0) this.bannerHeight = bh
        }
      })
    },

    // ResizeObserver only starts observing the banner once it exists in the DOM.
    observeBanner() {
      if (this._resizeObserver && this.$refs.resourceBanner) {
        this._resizeObserver.observe(this.$refs.resourceBanner)
      }
    },
  },

  watch: {
    showResourceBanner() {
      this.$nextTick(() => {
        this.measureLayout()
        this.observeBanner()
      })
    },

    // The user often resolves after mount (async /auth/me) — restart the idle
    // tracker when the role-based timeout changes.
    idleTimeoutMs() {
      this.startIdleTracking()
    },
  },

  mounted() {
    this.measureLayout()
    window.addEventListener('resize', this.measureLayout)
    window.addEventListener('orientationchange', this.measureLayout)
    if (typeof ResizeObserver !== 'undefined') {
      this._resizeObserver = new ResizeObserver(() => {
        this.measureLayout()
      })
      const navEl = this.$refs.topNavbar && this.$refs.topNavbar.$el
      if (navEl) this._resizeObserver.observe(navEl)
      this.observeBanner()
    }

    // Periodically refresh unread notifications so time-sensitive UI updates
    // without the user navigating — in particular the "What's New" banner
    // clears once the CMS resource is deleted and its notification is removed
    // server-side. Skipped while the tab is hidden to avoid needless requests.
    this._notifPoll = setInterval(() => {
      if (typeof document !== 'undefined' && document.hidden) return
      this.getUnreadNotifications().catch(() => {})
    }, 60000)

    // Log the user out after a period of inactivity. MainLayout remounts on
    // tab-to-tab navigation, but the activity timestamp lives in localStorage
    // so the idle clock survives remounts (and is shared across browser tabs).
    this.startIdleTracking()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.measureLayout)
    window.removeEventListener('orientationchange', this.measureLayout)
    if (this._resizeObserver) {
      this._resizeObserver.disconnect()
      this._resizeObserver = null
    }
    if (this._notifPoll) {
      clearInterval(this._notifPoll)
      this._notifPoll = null
    }
    if (this._stopIdleLogout) {
      this._stopIdleLogout()
      this._stopIdleLogout = null
    }
  },

  async created() {
    // Only show the full-page overlay on the very first load (no auth user yet).
    // On tab-to-tab navigation MainLayout is remounted but auth is already cached,
    // so we skip the flash.
    const needsAuthFetch = !this.user
    if (needsAuthFetch) this.show = true
    await this.getAuthenticatedUser()
    this.show = false
    this.getUserNotifications()

    if (this.canPurchaseTokens) {
      this.getBalance()
    }

    if (
      this.user &&
      this.user.user_type === 'business_admin' &&
      !this.isProjectScoped
    ) {
      this.$store.dispatch('company/fetchCanSendMassNotification')
    }

    const tradieRestrictedRoutePaths = [
      'request.templates-page',
      'request.new-page',
      'request.view-requested-to-page',
      'request.edit-requested-to-page',
    ]

    if (
      this.isTradieUser &&
      tradieRestrictedRoutePaths.includes(this.$route.matched[1].name)
    ) {
      this.$router.replace({ name: 'page-not-found' })
    }
  },
}
</script>

<style scoped lang="scss">
@import '../assets/scss/main';

.top-navbar {
  // position: fixed;
  width: 100%;
  // min-width: 960px;
  z-index: 1031;
  box-shadow: 0px 3px 5px #00429d0d;

  /deep/ .navbar-collapse.show {
    max-height: calc(100vh - 52px);
    overflow-y: auto;
    padding-bottom: 1.5rem;
  }

  // Smaller "(Beta)" tag so beta tabs don't push the link list past the
  // Tokens/+New buttons at narrower desktop widths.
  /deep/ .nav-link .beta-tag {
    font-size: 0.7em;
    opacity: 0.8;
  }

  // Inline desktop nav (>= 1200px): structural no-overlap guarantee at every
  // width. The brand and the right-side controls (Tokens/+New/bell/avatar)
  // hold their size and can never be covered; only the centre link list
  // flexes, clipping at its own edge in the worst case rather than sliding
  // underneath its neighbours. Single line — no wrap, no horizontal scroll.
  @media (min-width: 1200px) {
    /deep/ .custom-container,
    /deep/ .navbar-collapse,
    /deep/ .navbar-collapse .navbar-nav {
      flex-wrap: nowrap;
    }

    /deep/ .navbar-collapse {
      min-width: 0;
    }

    /deep/ .navbar-collapse > .navbar-nav.m-auto {
      min-width: 0;
      overflow: hidden;
      // Transparent border = guaranteed visible gap between the link list's
      // clip edge and the buttons, so text never appears to touch them.
      border-right: 14px solid transparent;
    }

    /deep/ .navbar-collapse > .navbar-nav .nav-item {
      white-space: nowrap;
    }

    /deep/ .navbar-brand.d-xl-block,
    /deep/ .navbar-collapse .navbar-nav.d-xl-flex {
      flex-shrink: 0;
    }

    // Belt-and-braces: the right-side group is opaque and stacked above the
    // link list, so under any circumstances link text ends cleanly behind it
    // rather than showing through the buttons.
    /deep/ .navbar-collapse .navbar-nav.d-xl-flex {
      position: relative;
      z-index: 1;
      background: #fff;
    }

    // The avatar must never be squeezed into an ellipse by the nowrap flex
    // row — pin its circle dimensions, and make the photo inside cover the
    // circle instead of stretching to the image's own aspect ratio.
    /deep/ .navbar-collapse .navbar-nav.d-xl-flex .b-avatar {
      flex: 0 0 auto;
      width: 48px !important;
      height: 48px !important;
    }
  }

  // Avatar photos (any breakpoint): fill and centre-crop the circular frame
  // rather than letterboxing to the source image's own aspect ratio.
  // bootstrap-vue's own avatar CSS only exists here as scoped copies that
  // can't reach the component's internals, so the inner span's geometry is
  // pinned absolutely — immune to display/sizing quirks at any breakpoint.
  /deep/ .b-avatar {
    position: relative;
    overflow: hidden;
    border-radius: 50%;
  }

  /deep/ .b-avatar .b-avatar-img {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    display: block !important;
    border-radius: 50%;
    overflow: hidden;
  }

  /deep/ .b-avatar .b-avatar-img img,
  /deep/ .b-avatar > img {
    display: block;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: inherit;
  }

  // 1200-1629px: compact spacing so the full nav fits smaller windows.
  // Tightened again (was 0.25rem/0.5rem/0.9375rem) when the "Job Search" tab
  // joined the row — a 9th tab needs more give-back than one more round of
  // shaving the existing paddings gave.
  @media (min-width: 1200px) and (max-width: 1629.98px) {
    /deep/ .navbar-collapse > .navbar-nav .nav-item {
      padding-left: 0.125rem !important;
      padding-right: 0.125rem !important;
      font-size: 0.9rem;
    }

    /deep/ .navbar-collapse > .navbar-nav.m-auto .nav-link {
      padding-left: 0.375rem;
      padding-right: 0.375rem;
      font-size: 0.875rem;
    }

    /deep/ .navbar-brand.d-xl-block img {
      height: 28px;
    }

    /deep/ .navbar-collapse .navbar-nav.d-xl-flex .btn {
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }
  }

  // 1200-1299px: the beta-tagged tabs need one step tighter still to clear
  // the Tokens/+New buttons just above the collapse breakpoint.
  @media (min-width: 1200px) and (max-width: 1299.98px) {
    /deep/ .navbar-collapse > .navbar-nav.m-auto .nav-link {
      padding-left: 0.25rem;
      padding-right: 0.25rem;
      font-size: 0.8125rem;
    }
  }

  // >= 1630px: the container itself caps at 1440px (custom-container), so the
  // original px-4 (1.5rem) links overflow it at ANY window width — the nav
  // content needs more than the ~1394px that's ever available. Slimmer links
  // and buttons (tighter again, plus an explicit font-size now that "Job
  // Search" is a 9th tab) bring the full-size layout safely inside that cap.
  @media (min-width: 1630px) {
    /deep/ .navbar-collapse > .navbar-nav .nav-item {
      padding-left: 0.25rem !important;
      padding-right: 0.25rem !important;
      font-size: 0.9rem;
    }

    /deep/ .navbar-collapse > .navbar-nav.m-auto .nav-link {
      padding-left: 0.375rem;
      padding-right: 0.375rem;
      font-size: 0.9rem;
    }

    /deep/ .navbar-collapse .navbar-nav.d-xl-flex .btn {
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }
  }

  // Mobile/tablet (below the xl collapse breakpoint): the brand is hidden, so
  // the toggle row is the navbar's only visible child and everything hugged
  // the left edge. Stretch it across the full width and split it — hamburger
  // stays left, the Tokens/+New/bell/avatar group is pushed to the right
  // edge. At xl+ the row's contents are all hidden, and this rule doesn't
  // apply, so the desktop layout is untouched.
  @media (max-width: 1199.98px) {
    .mobile-toggle-row {
      flex-grow: 1;
      justify-content: space-between;
    }

    // Anchor the +New / avatar dropdown menus to their own toggle instead of
    // the fixed navbar (their previous absolute-position ancestor), which made
    // them render at the screen's left edge and clip off-screen. Right-align
    // to the toggle — the group now sits at the right edge — and cap the
    // menu's size to the viewport so no item is ever unreachable.
    .mobile-toggle-row .user-dropdown {
      position: relative;
    }

    .mobile-toggle-row .user-dropdown /deep/ .dropdown-menu {
      position: absolute;
      top: 100%;
      right: 0;
      left: auto;
      max-width: calc(100vw - 1rem);
      max-height: calc(100vh - 80px);
      overflow-y: auto;
    }
  }

  // Mobile: the toggle + icon row are grouped in .mobile-toggle-row (own
  // nowrap flex group — see template), so they stay on one line without
  // forcing nowrap on the whole container (which would break the opened
  // collapse menu's ability to drop onto its own row below). On very narrow
  // phones, tighten the icon group's spacing so everything actually fits.
  @media (max-width: 400px) {
    /deep/ .navbar-toggler {
      padding: 0.25rem 0.4rem;
    }

    /deep/ .navbar-nav.d-xl-none {
      // Even, consistent spacing between every icon — replaces the individual
      // custom margins below (zeroed out) so items don't crowd unevenly.
      gap: 0.3rem;

      // Bootstrap's default .nav-link padding (0.5rem 1rem) wraps every icon
      // and was the main space-eater; shrink it uniformly.
      .nav-link {
        padding: 0.25rem !important;
      }

      > .nav-item.px-1,
      .user-dropdown.px-2 {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }

      .user-dropdown.mr-2 {
        margin-right: 0 !important;
      }

      // The notification badge overhangs the bell icon's right edge, so give
      // it dedicated clearance beyond the shared gap to avoid touching the
      // avatar next to it.
      .notif-bell-item {
        margin-right: 0.55rem !important;
      }

      .b-avatar {
        width: 2rem !important;
        height: 2rem !important;
      }
    }
  }

  // Mobile/tablet brand on the far right of the top bar: shrink it on small
  // screens, and below ~510px there's no room next to the icon row at all.
  .mobile-brand img {
    @media (max-width: 767.98px) {
      height: 28px;
    }
  }

  // Below ~510px the full row (burger + logo + Tokens/+New/bell/avatar) no
  // longer fits and the avatar starts getting clipped at the right edge, so
  // drop the logo first — the controls take priority.
  @media (max-width: 509.98px) {
    .mobile-brand {
      display: none !important;
    }
  }

  /deep/ .user-dropdown-link {
    &:hover,
    &:focus,
    &:active {
      background-color: #eaf3ff !important;
      color: #006cff !important;
    }
  }

  /deep/ .nav-item.nav-item.nav-item {
    font-weight: bolder;

    &:hover,
    &:focus,
    &:active {
      background-color: #eaf3ff !important;
    }

    a {
      &:hover,
      &:focus,
      &:active {
        color: #006cff !important;
      }
    }
  }
}

.btn {
  height: 48px;
  padding: 4px 12px 8px 10px;
}

.btn.b-avatar {
  width: 48px;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.slot-container {
  height: 100%;
  // Baseline padding without !important so the inline padding-top bound in
  // the template (banner offset) can override it. Replaces the old `p-0`
  // utility class, whose !important silently killed that inline style.
  padding: 0;
  transition: padding-top 0.2s ease;
}

.nav-button {
  height: 36px;
  margin-right: 30px;
}

.mw-300 {
  min-width: 300px;
}

.bp-menu-icon {
  width: 24px;
  height: 24px;
  color: #2c66d5;
  vertical-align: middle !important;
}

.hidden-temp {
  @media (max-width: 767px) {
    display: none;
  }
}

.align-middle {
  vertical-align: middle;
}

.badge {
  position: absolute;
  transform: translateY(50%);
  bottom: 25px;
  left: 10px;
  // Bootstrap's .badge is an inline-block sized by its text + em padding, so a
  // single digit renders a tall/narrow oval that also sits high. Force a fixed
  // square box in px (deterministic, unlike the inherited-em font-size) and
  // center the digit both axes. border-radius is a pill, not 50%: an exact
  // circle at 18x18, and a rounded capsule (never an ellipse) if the count
  // ever reaches two digits. The box is 22px with a 2px ring so the digits
  // (even two, e.g. "19") have clear space and never touch the red edge.
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 5px;
  border: 2px solid;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

/deep/ .user-dropdown-menu-container {
  width: 12.5em;
}

.active {
  color: #006cff !important;
}

.top-action-btn {
  height: 48px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
}

.resource-banner {
  position: fixed;
  // top is set inline (bound to the measured navbar height) so the banner
  // always sits directly below the navbar on every screen size.
  top: 88px;
  left: 0;
  right: 0;
  z-index: 1029;
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid rgba(37, 99, 235, 0.1);
  border-left: 4px solid #2563eb;
  padding: 10px 52px 10px 20px;
  min-height: 52px;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.07);

  &__inner {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    flex-wrap: wrap;
    justify-content: center;
  }

  // Tighten the layout so everything fits on very small screens (down to 320px).
  @media (max-width: 575px) {
    padding: 8px 38px 8px 14px;

    &__inner {
      gap: 6px 8px;
      justify-content: flex-start;
    }

    &__icon-wrap {
      display: none;
    }

    &__label,
    &__message {
      font-size: 0.85rem;
    }

    &__cta {
      font-size: 0.75rem;
      padding: 5px 12px;
    }

    &__close {
      right: 6px;
    }
  }

  &__icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: rgba(37, 99, 235, 0.1);
    flex-shrink: 0;
    animation: banner-pulse 2.8s ease-in-out infinite;
  }

  &__icon {
    color: #2563eb;
    font-size: 1rem;
  }

  &__body {
    display: flex;
    align-items: baseline;
    gap: 6px;
    flex-wrap: wrap;
    flex: 0 1 auto;
    min-width: 0;
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    padding: 1px 7px;
    border-radius: 999px;
    background: #2563eb;
    color: #fff;
    font-size: 0.65rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    white-space: nowrap;
    flex-shrink: 0;
  }

  &__label {
    font-size: 1rem;
    font-weight: 700;
    color: #111827;
    white-space: nowrap;

    &::after {
      content: ' -';
      font-weight: 400;
      color: #9ca3af;
      margin-left: 2px;
    }
  }

  &__message {
    font-size: 1rem;
    color: #4b5563;
    line-height: 1.4;

    /deep/ a {
      color: #2563eb;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__cta {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: 6px 14px;
    border-radius: 6px;
    background: #2563eb;
    color: #fff !important;
    font-size: 0.8125rem;
    font-weight: 600;
    text-decoration: none !important;
    white-space: nowrap;
    flex-shrink: 0;
    transition: background 0.15s ease, transform 0.12s ease,
      box-shadow 0.15s ease;
    box-shadow: 0 1px 4px rgba(37, 99, 235, 0.3);

    &:hover {
      background: #1d4ed8;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 1px 4px rgba(37, 99, 235, 0.3);
    }
  }

  &__cta-arrow {
    font-size: 1.1rem;
    transition: transform 0.15s ease;
  }

  &__cta:hover &__cta-arrow {
    transform: translateX(3px);
  }

  &__close {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 5px;
    color: #6b7280;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 1.1rem;
    border-radius: 4px;
    transition: background 0.12s, color 0.12s;

    &:hover {
      background: #f3f4f6;
      color: #111827;
    }
  }
}

@keyframes banner-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.2);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(37, 99, 235, 0);
  }
}
</style>
